import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

import MainLayout from "./pages/MainLayout";
import JudgeLayout from "./pages/JudgeLayout";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home"; 
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ClubList from "./pages/ClubList";
import FighterProfile from "./pages/Profile";
import PublicFighterProfile from "./pages/PublicFighterProfile";
import ClubProfile from "./pages/ClubProfile";
import TournamentBracket from "./pages/admin/TournamentBracket";
import ManageList from "./pages/admin/ManageList";
import TournamentManage from "./pages/admin/TournamentManage";
import TournamentCreate from "./pages/admin/TournamentCreate";
import AdminDashboard from "./pages/admin/AdminDashboard";
import TournamentList from "./pages/TournamentList";
import EnterTournament from "./pages/EnterTournament";
import BracketShow from "./pages/BracketShow";
import RegisteredFighters from "./pages/RegisteredFighters";
import MyTournamentFighters from "./pages/MyTournamentFighters";
import Ranking from "./pages/Ranking";
import JudgePage from "./pages/JudgePage";
import DisplayPage from "./pages/DisplayPage";
import UpcomingFights from "./pages/UpcomingFights";
import CreateEvent from "./pages/admin/CreateEvent";
import EventFighters from "./pages/EventFighters";
import Events from "./pages/Events";
import AdminCreateBracket from "./pages/AdminCreateBracket"; 
import TournamentRules from "./pages/admin/TournamentRules";
import TournamentRulesPublic from "./pages/TournamentRulesPublic";
import TournamentFightSchedule from "./pages/admin/TournamentFightSchedule";
import HomeCover from "./pages/admin/HomeCover";
import PublicFightSchedule from "./pages/Onoolt";

export default function App() {
  return (
    <Routes>

      {/* NORMAL WEBSITE */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/clubs" element={<ClubList />} />
        <Route path="/clubs/:id" element={<ClubProfile />} />
        <Route path="/fighters/:id" element={<PublicFighterProfile />} />
        <Route path="/tournaments" element={<TournamentList />} />
        <Route path="/tournaments/:tournamentId/register" element={<EnterTournament />} />
        <Route
  path="/tournaments/:tournamentId/my-fighters"
  element={<MyTournamentFighters />}
/>
<Route
  path="/admin/tournament/:id/fight-schedule"
  element={<TournamentFightSchedule />}
/>
<Route
    path="/tournaments/:id/onoolt"
    element={<PublicFightSchedule />}
/>
        <Route path="/tournaments/:tournamentId/brackets" element={<BracketShow />} />
        <Route path="/tournaments/:id/tourfighters" element={<RegisteredFighters />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:eventId/fighters" element={<EventFighters />} />
       <Route
  path="/tournaments/:id/rules"
  element={<TournamentRulesPublic />}
/>
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<FighterProfile />} />

          <Route element={<AdminRoute />}>
            <Route path="/admin/tournaments/:id/create-bracket" element={<AdminCreateBracket />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/home-cover" element={<HomeCover />} />
            <Route path="/admin/fighters/:id/edit" element={<FighterProfile />} />
            <Route path="/admin/tournament/create" element={<TournamentCreate />} />
            <Route path="/admin/tournament/:id" element={<TournamentManage />} />
            <Route path="/admin/tournament/:id/bracket" element={<TournamentBracket />} />
            <Route path="/admin/tournaments/:id/fighters" element={<ManageList />} />
            <Route path="/admin/events/create" element={<CreateEvent />} />
            <Route path="/admin/events/:eventId/fighters" element={<EventFighters />}
/>
<Route
  path="/admin/tournament/:id/rules"
  element={<TournamentRules />}
/>
          </Route>
        </Route>
      </Route>

      {/* JUDGING SYSTEM (NO HEADER, NO NAV) */}
      <Route element={<JudgeLayout />}>
        <Route path="/judge" element={<JudgePage />} />
        <Route path="/display" element={<DisplayPage />} />
        <Route path="/upcoming" element={<UpcomingFights />} />
      </Route>

    </Routes>
  );
}
